module.exports = __webpack_public_path__ + "static/logo-blue@3x-b6023b54df458403b2a270baa28c34fc.png";